import styles from "./confirm.module.scss";
import { useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Button, Flex, IconButton } from "ui";

export function Confirm({
  children,
  confirmText,
  description,
  onClose,
  hidden,
  onConfirm,
  title,
}) {
  const [open, setOpen] = useState(false);

  if (hidden || !children) return null;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (typeof onClose === "function") onClose();
  };

  return (
    <>
      <Box onClick={handleClickOpen}>{children}</Box>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={styles.root}
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title" className={styles.title}>
          <Flex justify="space-between">
            {title}
            <IconButton
              color="inherit"
              icon="close"
              size="small"
              hidden={onConfirm}
              variant="text"
              onClick={handleClose}
            />
          </Flex>
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            className={styles.description}
          >
            {description}
          </DialogContentText>
        </DialogContent>
        <DialogActions className={styles.actions}>
          <Button
            color="inherit"
            hidden={!onConfirm}
            variant="text"
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            color="black"
            hidden={!onConfirm}
            onClick={(e) => {
              if (typeof onConfirm === "function") onConfirm(e);
              handleClose();
            }}
            variant="contained"
            autoFocus
          >
            {confirmText || "Aceptar"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

Confirm.propTypes = {
  children: PropTypes.node.isRequired,
  description: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};
